import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import routes from '../routes/routes';
import {useTagsStore} from '../../common/stores/useTagsStore';
import {useEventDtoStore} from '../../common';
import {useEventDetailsStore} from '../../common';

export const AddEventButton: React.FC = () => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();
  const {clearSelectedTagCodes} = useTagsStore();
  const {clearEventDto} = useEventDtoStore();
  const {clearEventDetails} = useEventDetailsStore();

  const handleClick = () => {
    clearSelectedTagCodes();
    clearEventDto();
    clearEventDetails();
    navigate(routes.createEvent);
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title="Create new event"
      style={{
        position: 'fixed',
        bottom: 28,
        right: 28,
        zIndex: 9999,
        width: 56,
        height: 56,
        borderRadius: '50%',
        backgroundColor: isHovered ? '#c8e800' : '#daff00',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: 'none',
        transform: isHovered ? 'scale(1.1)' : 'scale(1)',
        transition: 'all 0.2s ease',
      }}>
      <span
        style={{
          fontSize: '1.8rem',
          fontWeight: 300,
          color: '#000',
          lineHeight: 1,
          marginTop: '-2px',
        }}>
        +
      </span>
    </button>
  );
};
